"use strict";
var Observable_1 = require('../../Observable');
var concat_1 = require('../../observable/concat');
Observable_1.Observable.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/observable/concat.js